<div class="jhmi-contacts jhm-page" [class.mobile]="screenSize==='MOBILE'">
  <div class="jhm-top-toolbar">
	<div class="left">
	  <div class="title-item">
		<div class="fa-solid fa-bars nav-open" (click)="openNav()"></div>
		<div class="title">
		  Contacts
		</div>
	  </div>
	</div>
	<div class="right">
	  <button class="action jhm-button primary" (click)="onNewContactClick()"><i class="fa-solid fa-plus"></i>New Contact</button>
	</div>
  </div>
  <jhm-table
	[refreshTableData]="refreshTableData"
	[repository]="contactRepository"
	[zeroState]="'contacts'"
	(cellClicked)="cellClicked($event)"
	(currentTableData)="setCurrentTableData($event)"
	(zeroStateActionClick)="onNewContactClick()">
  </jhm-table>
</div>

@if (showGiveCreditsModal) {
	<jhm-give-credits (exit)="showGiveCreditsModal = false; contactToGive = null;" [initialContacts]="[contactToGive]"></jhm-give-credits>
}

@if (showNewContactModal) {
	<jhm-add-contact [createNewContact]="createNewContact" (exit)="addContactExit($event)"></jhm-add-contact>
}

@if (loading) {
	<jhm-loading></jhm-loading>
}
@if (showAddContactModal) {
	<jhm-create-contact (exit)="createContactExit($event)"></jhm-create-contact>
}